import type { ReactNode } from 'react';
import styles from './checkbox-groups.module.scss';
const CheckBoxGroups = ({ children }: IProps) => {
	return <div className={styles.checkboxGroups}>{children}</div>;
};

export interface IProps {
	children: ReactNode;
}

export default CheckBoxGroups;
